const apiBaseUrl = process.env.REACT_APP_API_URL;
if (!apiBaseUrl) {
  throw new Error("REACT_APP_API_URL is required at build time");
}

// Trim a trailing slash so `${API_BASE_URL}/challenges` is always clean.
export const API_BASE_URL = apiBaseUrl.replace(/\/$/, "");

export const getApiEndpoint = (path: string): string => `${API_BASE_URL}${path}`;
